import palette from '@src/app/themes/palette';

export type WarningLevel = 'red' | 'amber';

export const WARNING_COLORS: Record<WarningLevel, string> = {
  red: palette.red['600'],
  amber: palette.orange['600'],
};

export type WarningItem = {
  code: string;
  message: string;
  severity: WarningLevel;
};

export function getWarningLevel(
  warnings: readonly { severity: WarningLevel }[],
): WarningLevel | null {
  if (warnings.some((warning) => warning.severity === 'red')) {
    return 'red';
  }
  return warnings.length > 0 ? 'amber' : null;
}

// Red warnings first; the order within a severity is kept.
export function sortWarningsBySeverity<T extends { severity: WarningLevel }>(
  warnings: readonly T[],
): T[] {
  return [...warnings].sort((first, second) => {
    if (first.severity === second.severity) {
      return 0;
    }
    return first.severity === 'red' ? -1 : 1;
  });
}
